import React, { useState /* , useCallback */ } from 'react';
import styles from './index.module.less';
import {
  Radio,
  Button,
  Row,
  Col,
  Card,
  Empty,
  Tooltip,
  Tag
  // Popconfirm,
  // Space
} from 'antd';
//import plus from '../../images/plus.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from 'common/Content/CustomTable';
import {
  PlusOutlined,
  // EditOutlined,
  // DeleteOutlined,
  ArrowLeftOutlined
} from '@ant-design/icons';
import { history } from 'app/history';
//import LocalStorage from 'utilities/localStorage';
import AllExportReports from '../reports/AllExportReports';
//import moment from 'moment';
//import { Value_of_gift } from '../../../../utilities/helpers';

const filters = [
  /*  {
    name: 'Gift Received',
    value: ''
  },
  {
    name: 'Pending',
    value: 'pending'
  },
  {
    name: 'Accepted',
    value: 'accepted'
  },
  {
    name: 'Rejected',
    value: 'rejected'
  } */
];

function SBGMasterFlowsPage({
  radiofilter,
  setRadiofilter,
  setTriggerFilter,
  page,
  setPage,
  pageSize,
  setPageSize,
  admin_sbgsList,
  pagination,
  get_BU_MasterLoading,
  setSearchRequest
  //showDisablePopup
  // setShowDisablePopup,
  // handleDeleteRequest
}) {
  // const admin_sbgsList1 = admin_sbgsList?.map((item) => ({
  //   key: item?.id,
  //   id: item?.id,
  //   name: item?.name,
  //   buCode: item?.code,
  //   status: item?.isActive,
  //   buHeadId: item?.SbuHeadId,
  //   sbgId: item?.SbgId
  // }));

  const [isAllExortModalOpen, setAllExortModalOpen] = useState(false);

  const columns = [
    {
      title: 'SBG Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: {
        showTitle: false
      },
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      render: (name) => {
        return (
          <>
            <Tooltip
              title={name}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {/* <a href={`view-gift-received-details/${record.id}`}> */}
              <span className={styles.text_transform}>
                {name === null ? '' : name}
              </span>
              {/*  </a> */}
            </Tooltip>
          </>
        );
      }
    },
    /*   {
      title: 'SBU/Function Head',
      dataIndex: 'buHead',
      key: 'buHead',
      // width: 400,
      ellipsis: true,
      // sorter: (a, b) => a.ticket - b.ticket,
      sorter: (a, b) => a?.buHead?.localeCompare(b?.buHead),
      render: (buHead) => {
        return (
          <>
            <Tooltip
              title={buHead}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {buHead === null ? '' : buHead}
            </Tooltip>
          </>
        );
      }
    },*/
    {
      title: 'SBG Head',
      dataIndex: 'sbgHead',
      key: 'sbgHead',
      // width: 400,
      ellipsis: true,
      // sorter: (a, b) => a.ticket - b.ticket,
      sorter: (a, b) => a?.sbgHead?.localeCompare(b?.sbgHead),
      render: (sbgHead, record) => {
        const sbgHeadName =
          record?.SbgHead?.givenName + ' ' + record?.SbgHead?.surname;
        // sbgHead?.givenName + ' ' + sbgHead?.surname;
        return (
          <>
            <Tooltip
              title={sbgHeadName}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {sbgHeadName === null || sbgHeadName === undefined
                ? 'NA'
                : sbgHeadName}
            </Tooltip>
          </>
        );
      }
    },
    /*  {
      title: 'Delegated On',
      dataIndex: 'delegated_date',
      key: 'delegated_date',
      ellipsis: true,
      sorter: (a, b) =>
        moment(a[`delegated_date`]).unix() - moment(b[`delegated_date`]).unix(),
      render: (delegated_date) => (
        <>
          <Tooltip
            title={
              delegated_date === null
                ? ''
                : moment(delegated_date).format('DD MMM YYYY')
            }
            color={'white'}
            overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
            arrowPointAtCenter="false"
          >
            {delegated_date === null
              ? ''
              : moment(delegated_date).format('DD MMM YYYY')}
          </Tooltip>
        </>
      )
    }, */
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      width: '120px',
      ellipsis: true,
      //sorter: (a, b) => a?.status?.localeCompare(b?.status),
      render: (isActive, record) => (
        <Tag
          className={`${styles.status_style}`}
          color={
            record?.isActive === true
              ? 'green'
              : record?.isActive === false
              ? 'red'
              : 'transparent'
          }
        >
          {record?.isActive === true ? 'ACTIVE' : 'DEACTIVATED'}
        </Tag>
      )
    }
    /*  {
      title: 'Action',
      key: '',
      width: 180,
      render: (record) => (
        <>
          <Space size="middle">
            <>
              <Popconfirm
                placement="top"
                title="Are you sure you want to delete this SBU?"
                open={visibility(record)}
                onConfirm={() => {
                  handleDeleteRequest({
                    record: record
                  });
                }}
                onCancel={() => {
                  setShowDisablePopup({});
                }}
                okText="Delete"
                cancelText="No"
                okButtonProps={{ type: 'danger' }}
              >
                <a
                  className={`${styles.allocation_btn}`}
                  style={{
                    fontSize: '12px'
                  }}
                  type="link"
                  disabled={record?.status === false}
                >
                  <DeleteOutlined className={`${styles.delete_bu}`} />
                </a>
              </Popconfirm>
            </>
          </Space>
          <EditOutlined
            className={`${styles.edit_bu}`}
            onClick={() => handleBU_record(record)}
          />
        </>
      )
    } */
  ];

  // const visibility = useCallback((record) => {
  //   return showDisablePopup[record.id];
  // }, showDisablePopup);

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        {/*  <Image alt="users_empty_state" src={emptyState} preview={false} /> */}
        <div className={styles.empty_state_text}>
          There are no SBG to display
        </div>
      </span>
    )
  };

  return (
    <>
      <div className={`${styles.container}`}>
        <Row className={`${styles.row_container}`}>
          <div className={`${styles.gift_container}`}>
            <div className={`${styles.myGift_title}`}>Configure SBG Master</div>
            <div className={`${styles.myGift_text}`}>
              View and manage SBG Master
            </div>
          </div>
          <div className={`${styles.declareGift_div}`}>
            <Row>
              <Button
                className={`${styles.export_button}`}
                onClick={() => setAllExortModalOpen(true)}
              >
                Export
              </Button>
              <Button
                className={`${styles.declareGift_button}`}
                icon={<PlusOutlined />}
                onClick={() => history.push('/create-sbg-master-flow')}
              >
                Add New SBG
              </Button>
              <Button
                style={{ marginLeft: '20px' }}
                className={`${styles.declareGift_button}`}
                icon={<ArrowLeftOutlined />}
                onClick={() => history.push('/admin')}
              >
                Back
              </Button>
            </Row>
          </div>
        </Row>
        <div className={`${styles.tabs_container}`}>
          <Row>
            {/* className={`${styles.row_container}`} */}
            <Col span={16}>
              <Radio.Group
                value={radiofilter}
                size="small"
                className={`${styles.button_import_style}`}
              >
                {filters.map((item, index) => {
                  return (
                    <Radio.Button
                      value={item.value}
                      key={index}
                      //className={`${styles.RadioButton_import_style}`}
                      onChange={() => {
                        window.localStorage.setItem(
                          'set_Radiofilter',
                          JSON?.stringify(item.value)
                        );
                        setRadiofilter(item.value);
                        setTriggerFilter(true);
                      }}
                    >
                      {item.name}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Col>
            <Col span={8}>
              <SearchBar
                onChange={(e) => {
                  setSearchRequest(e.target.value);
                  setTriggerFilter(true);
                }}
                className={` ${styles.searchbar}`}
                inputProps={{
                  placeholder: 'Search by SBG name'
                }}
              />
            </Col>
          </Row>
        </div>
        <Card className={`${styles.cardStyles}`}>
          <div className={`${styles.table_container}`}>
            <CustomTable
              showSorterTooltip={false}
              columns={columns}
              dataSource={admin_sbgsList}
              locale={locale}
              loading={get_BU_MasterLoading}
              pagination={{
                current: page,
                pageSize: pageSize,
                showSizeChanger: true,
                size: 'small',
                total: pagination?.total_records || 0,
                onChange: (page, pageSize) => {
                  setPage(page);
                  setPageSize(pageSize);
                }
              }}
            />
          </div>
        </Card>
        {isAllExortModalOpen ? (
          <AllExportReports
            isAllExortModalOpen={isAllExortModalOpen}
            setAllExortModalOpen={setAllExortModalOpen}
            apiName={'bu_and_sbgs_master'}
          />
        ) : (
          ''
        )}
      </div>
    </>
  );
}
export default SBGMasterFlowsPage;
